<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">My Profile</li>
            </ol>
        </nav>

        <template v-if="loading">
            <i class="fa fa-spin fa-spinner"></i> Loading
        </template>
        <template v-else>
            <div class="row mb-3">
                <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.first_name, 'text-muted': !errors.first_name}">First Name:</div>
                <div class="col-lg-5 col-md-6 col-12 input-group-sm">
                    <input type="text" v-model="user.first_name" :class="{'form-control': true, 'is-invalid': errors.first_name}" placeholder="Enter First name" />

                    <div class="text-danger mt-2" v-if="errors.first_name">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.first_name">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.last_name, 'text-muted': !errors.last_name}">Last Name:</div>
                <div class="col-lg-5 col-md-6 col-12 input-group-sm">
                    <input type="text" v-model="user.last_name" :class="{'form-control': true, 'is-invalid': errors.last_name}" placeholder="Enter Last Name" />

                    <div class="text-danger mt-2" v-if="errors.last_name">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.last_name">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.timezone_id, 'text-muted': !errors.timezone_id}">
                    Timezone:
                </div>
                <div class="col-lg-5 col-md-6 col-12 input-group-sm">
                    <b-form-select v-model="user.timezone_id" :options="timezoneOptions" :class="{'is-invalid': errors.timezone_id}" />

                    <div class="text-danger mt-2" v-if="errors.timezone_id">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.timezone_id">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr/>

            <!-- <div class="row mb-4">
                <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.password, 'text-muted': !errors.password}">Password:</div>
                <div class="col-md-6 col-12">
                    <input type="password" v-model="password" :class="{'form-control': true, 'is-invalid': errors.password}" placeholder="Enter User Password" />

                    <div class="text-danger mt-2" v-if="errors.password">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.password">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.password_confirmation, 'text-muted': !errors.password_confirmation}">Confirm Password:</div>
                <div class="col-md-6 col-12">
                    <input type="password" v-model="password_confirmation" :class="{'form-control': true, 'is-invalid': errors.password_confirmation}" placeholder="Confirm Password" />

                    <div class="text-danger mt-2" v-if="errors.password_confirmation">
                        <ul class="list-unstyled">
                            <li v-for="err in errors.password_confirmation">{{ err }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr/> -->

            <div class="row">
                <div class="col-md-3 col-12 text-md-right text-muted"></div>
                <div class="col-md-6 col-12">
                    <button type="button" class="btn btn-sm btn-success" v-if="!id" v-on:click="saveProfile()">Update Profile</button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                user: {},
                errors: {},
                timezones: [],
                //password: null,
                //password_confirmation: null,
            }
        },

        computed: {

            timezoneOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Timezone --'}];

                //Build it
                for (var i = this.timezones.length - 1; i >= 0; i--)
                {
                    options.push({value: this.timezones[i].id, text: this.timezones[i].display_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getProfile(){
                //Send it
                this.$http.get('/users/profile')
                    .then(response => {
                        //Set the user
                        this.timezones = response.data.timezones;

                        //Set the user
                        this.user = this.$store.state.user;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            saveProfile(){
                //Helpers
                this.saving = true;

                //Helpers
                //this.user.password = this.password;
                //this.user.password_confirmation = this.password_confirmation;

                //Send it
                this.$http
                .post('/users/profile', this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Profile Updated');

                    //Update the user
                    this.$store.commit('login', response.data);

                    //Return to main list?
                    this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Update Profile');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }

        },

        mounted() {
            //Get the resources
            this.getProfile();
        }
    }
</script>
